import { Component, Type, Inject } from '@angular/core';
import { IGetClass, IModalWindow } from '../../../utils/interfaces/modal-dialog.interface';
import { ModalWindowsTypes } from '../../../core/enums';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialogModule } from '@angular/material/dialog';
import { TranslateModule } from '@ngx-translate/core';


@Component({
    selector: 'asg-file-moving-warning-dialog',
    templateUrl: './file-moving-warning-dialog.component.html',
    styleUrls: ['./file-moving-warning-dialog.component.scss'],
    standalone: true,
    imports: [MatDialogModule, TranslateModule]
})
export class FileMovingWarningDialogComponent implements IModalWindow, IGetClass {
  messages: Array<{ text: string, folderName: string }>;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    public dialogRef: MatDialogRef<FileMovingWarningDialogComponent>,
  ) {
    this.messages = data.messages;
  }

  getWindowType(): Type<IModalWindow> {
    return FileMovingWarningDialogComponent;
  }

  getWindowEnumType(): ModalWindowsTypes {
    return ModalWindowsTypes.FILE_MOVING_WARNING_DIALOG;
  }

  getInstanceOf(type: string): IModalWindow | IGetClass | null {
    switch (type) {
      case 'IModalWindow':
        return this as unknown as IModalWindow;
      case 'IGetClass':
        return this as unknown as IGetClass;
      default: return null;
    }
  }

  getClass(): string {
    return 'move-warning-dlg';
  }

  closeDlg(status: boolean): void {
    this.dialogRef.close(status);
  }
}
